import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import css from "./UserPage.module.css";
import { getResDataFirebase } from "../../Utils/firebaseResearch";
import { ResearchContext } from "../../Context/ResearchContext";

export const ParticipantsPage = () => {
  const { participants } = useContext(ResearchContext);
  const navigate = useNavigate();

  return (
    <section className={css.container}>
      <div>
        <h2>Participantes da pesquisa</h2>
        <div>
          {!participants?.length ? (
            <p>Não foram encontrados participantes cadastrados na pesquisa</p>
          ) : (
            participants.map((p) => (
              <div key={p.id} className={css.card}>
                <div className={css.cardBody}>
                  <p>Id: {p.id}</p>
                  <p>
                    Cadastro em:{" "}
                    {new Date(p.createdAt).toLocaleDateString("pt-BR", {
                      weekday: "long",
                      day: "2-digit",
                      month: "2-digit",
                      year: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </p>
                  {p.commitmentAgreement ? (
                    <button
                      className="greenButton"
                      onClick={() => navigate(`/research/${p.id}`)}
                    >
                      Retornar
                    </button>
                  ) : (
                    <button
                      className="saveButton"
                      onClick={() => navigate(`/research/${p.id}`)}
                    >
                      Iniciar
                    </button>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  );
};
